import { render, staticRenderFns } from "./MobileFilters.vue?vue&type=template&id=bc940ac4&"
import script from "./MobileFilters.vue?vue&type=script&lang=js&"
export * from "./MobileFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports